import {handleApplePayDomainRegistration, handleApplePayDomainReset} from './applepay-domain-registration';
import {handleGatewayButtonAjax} from './gateway-ajax';
import {handleStripeCaptureVoidForm} from './stripe/capture-void-payment';
import {gatewayCurrencyAndCountryFilters, hideCustomCountriesAndCurrenciesOptions, insertControlButtons, displaySeeMoreButtons} from './gateway-settings';
import {initNavigationUIState} from './navigation';
import {handleAuthnetCaptureVoidForm} from './authnet/capture-void-payment';
import {initUIEvents} from './ui-events';
import {handleDisputeSettingsUi} from './stripe/dispute-setting-ui';
import './deactivation-feedback';
import {relatedProductsToggleUI} from './related-products';
import {botProtectionUI} from './bot-protection';

document.addEventListener('DOMContentLoaded', () => {
	// Admin settings scripts
	initUIEvents();
	initNavigationUIState();

	handleGatewayButtonAjax();
	handleApplePayDomainRegistration('square');

	// Gateway settings
	gatewayCurrencyAndCountryFilters();
	hideCustomCountriesAndCurrenciesOptions();
	insertControlButtons();
	displaySeeMoreButtons();

	// Stripe Admin scripts
	handleApplePayDomainRegistration('stripe');
	handleStripeCaptureVoidForm();
	handleDisputeSettingsUi();

	// Authnet Admin scripts
	handleAuthnetCaptureVoidForm();

	handleApplePayDomainReset();

	// Related Products Settings Page UI
	relatedProductsToggleUI();

	// Bot protection settings page UI
	botProtectionUI();
});

